import { GetWeavePopNotificationByType } from '@frontend/types';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

type Props = {
  onView?: (notification: GetWeavePopNotificationByType<'voicemail-tag'>) => void;
};

export const useVoicemailTagNotification = ({ onView }: Props = {}) => {
  const { create, remove } = useNotification<'voicemail-tag'>();
  useCommonActionSubscriptions('voicemail-tag');

  useNotificationActionSubscription(
    'voicemail-tag',
    'view',
    (e) => {
      onView?.(e.notification);
      remove(e.notification.id);
    },
    [onView]
  );

  return {
    create,
    remove,
  };
};
